import { InjectionToken } from '@angular/core';

import { DoodProductModel } from '@core/models/product.model';

/** Resource-like suggestions state consumed by the block template. */
export type CartSuggestionCardsSuggestionsState = {
  readonly hasValue: boolean;
  readonly value: DoodProductModel[] | undefined;
  readonly isLoading: boolean;
};

/** Runtime VM emitted by `CartSuggestionCardsBlock` data sources. */
export type CartSuggestionCardsBlockViewModel = {
  suggestions: CartSuggestionCardsSuggestionsState;
};

export const CART_SUGGESTION_CARDS_BLOCK_LOADING_VM: CartSuggestionCardsBlockViewModel = {
  suggestions: {
    hasValue: false,
    value: undefined,
    isLoading: true,
  },
};

export interface CartSuggestionCardsBlockDataSource {
  readonly vm$: import('rxjs').Observable<CartSuggestionCardsBlockViewModel>;
}

export const CART_SUGGESTION_CARDS_BLOCK_DATA_SOURCE =
  new InjectionToken<CartSuggestionCardsBlockDataSource>('CART_SUGGESTION_CARDS_BLOCK_DATA_SOURCE');

/** Writable suggestions-set id bound from the block input in production. */
export const CART_SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET = new InjectionToken<
  import('@angular/core').WritableSignal<string | undefined>
>('CART_SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET');
